import editStatusSelector from 'app/App/selectors/editStatus';
import { clearComponentUsage } from 'app/ComponentUsage/actions';
import { getComponentUsage } from 'app/ComponentUsage/thunks';
import { visitComponent } from 'app/Router/actions';
import connect from 'utils/store/connect';

import PublishComponent from './components/PublishComponent';
import { publishComponentThunk } from './thunks';

/**
 * Return object mapping state to prop
 * @param {object} state - Redux state object
 * @returns {object} Object for react props
 */
export const mapStateToProps = state => ({
  editStatus: editStatusSelector(state)
});

/**
 * Returns object mapping dispatches to props
 * @returns {object}
 */
export const mapDispatchToProps = {
  clearComponentUsage,
  getComponentUsage,

  // TODO use a selector once the information exists in store
  isReadonly: false,
  onPublish: publishComponentThunk,
  visitComponent
};

export default connect(mapStateToProps, mapDispatchToProps)(PublishComponent);
